module.exports = __webpack_public_path__ + "11148edb9c9e0b0797aa05af997cd1fd.fbx";